import React from 'react'
import Hero from '../../component/home/Hero'
import Features from '../../component/home/Features'
import Showcase from '../../component/home/Showcase'
import Testimonials from '../../component/home/Testimonials'
import FinalCTA from '../../component/home/FinalCTA'
import Footer from '../../component/home/Footer'

const Home = () => {
  return (
    <div className="min-h-screen bg-black overflow-x-hidden">
      <Hero />
      <Features />
      <Showcase />
      {/* <Testimonials /> */}
      <FinalCTA />
      <Footer />
    </div>
  )
}

export default Home